import React, { useState } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { theme } from 'utils/style/theme';
import { adminUserApi } from 'apis/adminUserApis';
import FullLayout from 'components/layout/FullLayout';
import DefaultInput from 'components/input/DefaultInput';
import SubmitButton from 'components/button/SubmitButton';
/**
 * * 회원 가입
 */

const JoinPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [adminData, setAdminData] = useState({
    name: '',
    email: '',
  });

  const handleChangeName = (e) => {
    const newData = e.target.value;
    setAdminData({ ...adminData, name: newData });
  };

  const handleChangeEmail = (e) => {
    const newData = e.target.value;
    setAdminData({ ...adminData, email: newData });
  };

  const handleReset = (text) => (e) => {
    if (text === 'name') {
      setAdminData({ ...adminData, name: '' });
    }
    if (text === 'email') {
      setAdminData({ ...adminData, email: '' });
    }
  };

  // 시작하기 => 데이터 서버 전송
  const handleSubmit = async () => {
    const response = await adminUserApi.join(
      location.state.googleId,
      adminData,
    );
    // console.log(response);
    if (response.code === 'OK') {
      alert(
        `가입 신청이 완료되었습니다. \n관리자에게 승인 요청 후, 재로그인 해주세요.`,
      );
      navigate('/login');
    }
  };
  return (
    <FullLayout>
      <ContentBox>
        <table>
          <tbody>
            <tr>
              <th>
                <div>
                  <span>* </span>이름
                </div>
              </th>
              <td>
                <DefaultInput
                  name='name'
                  onChange={handleChangeName}
                  value={adminData.name}
                  onClick={handleReset('name')}
                />
                <span>실명을 기입해주세요.</span>
              </td>
            </tr>
            <tr>
              <th>
                <div>
                  <span>* </span>이메일
                </div>
              </th>
              <td>
                <DefaultInput
                  name='email'
                  onChange={handleChangeEmail}
                  value={adminData.email}
                  onClick={handleReset('email')}
                />
                <span>정확한 이메일을 입력해주세요.</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div>
          <SubmitButton onClick={handleSubmit}>시작하기</SubmitButton>
        </div>
      </ContentBox>
    </FullLayout>
  );
};

export default JoinPage;
const ContentBox = styled.div`
  margin-top: 20px;
  table {
    background-color: #fff;
    width: 90%;
    margin: 0 auto;

    th {
      width: 4rem;
      height: 6rem;
      font-weight: 900;
    }
    th > div {
      /* background-color: brown; */
      margin-top: -15px;
      font-weight: 900;
    }
    th > div > span {
      font-size: 14px;
    }
    td {
      width: 20rem;
    }
    span {
      color: ${theme.colors.redText};
      font-weight: 600;
      font-size: 11.8px;
    }
  }
  > div {
    /* width: 100%; */
    /* background-color: blueviolet; */
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
`;
